import * as tokens from '../../../../../tokens/color.dark.generated.js';
export const semanticColorDark = {
    color: {
        action: {
            primary: {
                surface: {
                    fill: {
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DISABLED_DARK
                    },
                    stroke: {
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_DISABLED_DARK
                    }
                },
                foreground: {
                    icon: {
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DISABLED_DARK
                    },
                    text: {
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DISABLED_DARK
                    }
                }
            },
            secondary: {
                surface: {
                    fill: {
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_DISABLED_DARK
                    },
                    stroke: {
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_HOVER_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_DISABLED_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_PRESSED_DARK
                    }
                },
                foreground: {
                    icon: {
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_DISABLED_DARK
                    },
                    text: {
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_DISABLED_DARK
                    }
                }
            },
            tertiary: {
                surface: {
                    fill: {
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_DISABLED_DARK
                    },
                    stroke: {
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_DISABLED_DARK
                    }
                },
                foreground: {
                    icon: {
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_DISABLED_DARK
                    },
                    text: {
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_DISABLED_DARK
                    }
                }
            }
        },
        forms: {
            foreground: {
                icons: {
                    default: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_DEFAULT_DARK,
                    disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_DISABLED_DARK,
                    error: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_ERROR_DARK,
                    interactive: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_INTERACTIVE_DARK
                },
                text: {
                    error: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_ERROR_DARK,
                    default: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_DEFAULT_DARK,
                    interactive: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_INTERACTIVE_DARK,
                    caption: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_CAPTION_DARK,
                    disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_DISABLED_DARK
                },
                divider: {
                    default: tokens.SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_DARK
                }
            },
            surface: {
                control: {
                    stroke: {
                        error: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_ERROR_DARK,
                        readOnly: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_READ_ONLY_DARK,
                        disabled: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_DISABLED_DARK,
                        default: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_DEFAULT_DARK,
                        interactive: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_INTERACTIVE_DARK
                    },
                    indicator: {
                        default: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_DEFAULT_DARK,
                        interactive: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_DARK,
                        readOnly: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_READ_ONLY_DARK,
                        disabled: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_DISABLED_DARK,
                        error: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_ERROR_DARK
                    },
                    fill: {
                        readOnly: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_FILL_READ_ONLY_DARK
                    }
                },
                underline: {
                    stroke: {
                        error: tokens.SEM_COLOR_FORMS_SURFACE_UNDERLINE_STROKE_ERROR_DARK,
                        default: tokens.SEM_COLOR_FORMS_SURFACE_UNDERLINE_STROKE_DEFAULT_DARK,
                        interactive: tokens.SEM_COLOR_FORMS_SURFACE_UNDERLINE_STROKE_INTERACTIVE_DARK,
                        disabled: tokens.SEM_COLOR_FORMS_SURFACE_UNDERLINE_STROKE_DISABLED_DARK
                    }
                }
            }
        },
        navigation: {
            foreground: {
                indicator: {
                    active: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_INDICATOR_ACTIVE_DARK,
                    inactive: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_INDICATOR_INACTIVE_DARK
                },
                icon: {
                    interactive: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_ICON_INTERACTIVE_DARK,
                    disabled: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_ICON_DISABLED_DARK
                },
                text: {
                    active: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_ACTIVE_DARK,
                    interactive: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_INTERACTIVE_DARK,
                    idle: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_IDLE_DARK,
                    disabled: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_DISABLED_DARK
                }
            },
            surface: {
                fill: {
                    pressed: tokens.SEM_COLOR_NAVIGATION_SURFACE_FILL_PRESSED_DARK
                }
            }
        },
        feedback: {
            foreground: {
                text: {
                    default: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_DEFAULT_DARK,
                    inverted: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_INVERTED_DARK,
                    informative: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_INFORMATIVE_DARK
                }
            },
            surface: {
                informative: tokens.SEM_COLOR_FEEDBACK_SURFACE_INFORMATIVE_DARK,
                success: tokens.SEM_COLOR_FEEDBACK_SURFACE_SUCCESS_DARK,
                notice: tokens.SEM_COLOR_FEEDBACK_SURFACE_NOTICE_DARK,
                error: tokens.SEM_COLOR_FEEDBACK_SURFACE_ERROR_DARK
            }
        },
        ui: {
            surface: {
                scrim: { default: tokens.SEM_COLOR_UI_SURFACE_SCRIM_DEFAULT_DARK }
            },
            foreground: {
                divider: {
                    default: tokens.SEM_COLOR_UI_FOREGROUND_DIVIDER_DEFAULT_DARK
                },
                icons: {
                    default: tokens.SEM_COLOR_UI_FOREGROUND_ICONS_DEFAULT_DARK,
                    interactive: tokens.SEM_COLOR_UI_FOREGROUND_ICONS_INTERACTIVE_DARK,
                    disabled: tokens.SEM_COLOR_UI_FOREGROUND_ICONS_DISABLED_DARK
                },
                text: {
                    default: tokens.SEM_COLOR_UI_FOREGROUND_TEXT_DEFAULT_DARK,
                    interactive: tokens.SEM_COLOR_UI_FOREGROUND_TEXT_INTERACTIVE_DARK,
                    disabled: tokens.SEM_COLOR_UI_FOREGROUND_TEXT_DISABLED_DARK
                }
            }
        }
    }
};
//# sourceMappingURL=color.dark.js.map